/**
 * /livret-am — Livret interactif Permis AM (BSR, 8 h).
 * Réservé aux comptes élève / enseignant / admin (via ProtectedRoute).
 */
import React from 'react';
import LivretInteractif from '../../components/livrets/LivretInteractif';
import { LIVRET_AM } from '../../data/livretAmData';

export default function LivretAM() {
  return <LivretInteractif data={LIVRET_AM} testid="livret-am" />;
}
